import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import { DemouserLayer } from "../components/Gamesuser/DemouserLayer";

export const DemoUserListPage = () => {
  return (
    <MasterLayout>
      <DemouserLayer />
    </MasterLayout>
  );
};
